import { render } from "./ProsesKategoriData.vue?vue&type=template&id=8e8d73a6"
import script from "./ProsesKategoriData.vue?vue&type=script&lang=js"
export * from "./ProsesKategoriData.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__